export default __webpack_public_path__ + "static/media/finances-icon.f04da2c6.svg";